import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { Edit2, Trash2, X, Check, CheckSquare } from 'react-feather'

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from '../../../../common'

export const TableOperations = ({ useFetchInit }) => {
    
    const {
        FetchData,
        Actions
    } = useFetchInit

    const { fetchOperationsByUser } = FetchData
    const { dataOperations, loadingFetchOperations } = fetchOperationsByUser

    const { 
        handleClickFetchSpecificOperation,
        handleClickEnableUser,
        handleClickEnableDisableOperation,
        handleClickDeleteOperation,
        handleClickMakeOperation
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: 'fecha_operacion', headerName: 'FECHA', minWidth: 150, filter: true },
        { field: 'caja', headerName: 'CAJA', minWidth: 350, filter: true },
        { field: 'currency_type', headerName: 'TIPO', minWidth: 100, filter: true },
        { field: 'categoria', headerName: 'CATEGORIA', minWidth: 200, filter: true },
        { field: 'username', headerName: 'USUARIO', minWidth: 150, filter: true },
        { field: 'nombre_usuario', headerName: 'NOMBRE', minWidth: 300, filter: true },
        {
            headerName: 'Opciones',
            minWidth: 350,
            cellRenderer: (params) => {
                const { idoperacion, estado } = params.data

                // const readOnlyMode = estado === 1 ? 'EDITABLE' : 'READONLY'

                return (
                    <CustomDropDown color={(estado===1)?'inherit':'error'}>
                        {(estado === 1) && (
                            <div>
                                <MenuItem
                                    onClick={() => handleClickFetchSpecificOperation(idoperacion)}
                                >
                                    <ListItemIcon> <Edit2 color="black"/> </ListItemIcon>
                                    <ListItemText primary="Informacion" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickDeleteOperation(idoperacion)}
                                >
                                    <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                                    <ListItemText primary="Eliminar" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickEnableDisableOperation(idoperacion, 0)}
                                >
                                    <ListItemIcon> <X color="black"/> </ListItemIcon>
                                    <ListItemText primary="Cerrar" />
                                </MenuItem>
                                <div className="border-bottom border-dark"></div>
                                <MenuItem
                                    onClick={() => handleClickMakeOperation(idoperacion)}
                                >
                                    <ListItemIcon> <CheckSquare color="black"/> </ListItemIcon>
                                    <ListItemText primary="Creditos" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickMakeOperation(idoperacion)}
                                >
                                    <ListItemIcon> <CheckSquare color="black"/> </ListItemIcon>
                                    <ListItemText primary="Vehiculos" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickMakeOperation(idoperacion)}
                                >
                                    <ListItemIcon> <CheckSquare color="black"/> </ListItemIcon>
                                    <ListItemText primary="Predio Judicial" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickMakeOperation(idoperacion)}
                                >
                                    <ListItemIcon> <CheckSquare color="black"/> </ListItemIcon>
                                    <ListItemText primary="Venta de Vehiculos" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickMakeOperation(idoperacion)}
                                >
                                    <ListItemIcon> <CheckSquare color="black"/> </ListItemIcon>
                                    <ListItemText primary="Abogacia & Notariado" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickMakeOperation(idoperacion)}
                                >
                                    <ListItemIcon> <CheckSquare color="black"/> </ListItemIcon>
                                    <ListItemText primary="Arrendamientos" />
                                </MenuItem>
                            </div>
                        )}
                        {(estado === 0) && (
                            <MenuItem
                                onClick={() => handleClickEnableDisableOperation(idoperacion, 1)}
                            >
                                <ListItemIcon> <Check color="black"/> </ListItemIcon>
                                <ListItemText primary="Abrir" />
                            </MenuItem>
                        )}
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {(loadingFetchOperations)&&(<LinearLoading/>)}
            <CustomTableData 
                // datos (listados, individuales)
                rowConfig={dataOperations}
                columnConfig={columnConfig}
                // handleClicks
                // Funciones
            />
        </div>
    )
}
